import { ApiService } from '../apiService'

export interface FriendLiveLocationDto {
  userId: string
  userName: string
  avatarUrl: string | null
  latitude: number
  longitude: number
  timestamp: string
  isHidden: boolean
  hiddenReason: string | null
}

export const liveLocationApi = {
  // Get live locations of all friends
  getFriendsLiveLocations: () =>
    ApiService.get<FriendLiveLocationDto[]>('/api/me/friends/locations'),

  // Update own live location
  updateLocation: (latitude: number, longitude: number, accuracy?: number) =>
    ApiService.post<void>('/api/me/current-location', {
      latitude,
      longitude,
      accuracy: accuracy ?? 0,
      timestamp: new Date().toISOString(),
    }),

  // Stop sharing location (clear current location)
  stopSharing: () =>
    ApiService.delete<void>('/api/me/current-location'),
}
